<div class="sync-progress-dialog" *ngIf="viewModel$ | async as vm">
  <h2>{{ 'SYNC_PROGRESS.TITLE' | translate }}</h2>

  <p class="status" *ngIf="!vm.pausedStatusText" [ngClass]="{'banner': vm.status !== 'running', 'banner-success': vm.resultBannerClass === 'success', 'banner-error': vm.resultBannerClass === 'error'}">{{ vm.statusText }}</p>
  <p class="status banner banner-neutral" *ngIf="vm.pausedStatusText">{{ vm.pausedStatusText }}</p>

  <div class="section">
    <div class="row">
      <span>{{ 'SYNC_PROGRESS.TOTAL_LABEL' | translate:{ processed: vm.processedTasks, synced: vm.syncedTasks, failed: vm.failedTasks, total: vm.totalTasks } }}</span>
      <span>{{ vm.globalProgress }}%</span>
    </div>
    <mat-progress-bar mode="determinate" [value]="vm.globalProgress"></mat-progress-bar>
  </div>

  <div class="section" *ngIf="vm.status === 'running'">
    <p class="status task-phase">{{ 'SYNC_PROGRESS.TASK_LABEL' | translate:{ stage: vm.taskProgressLabel } }}</p>
  </div>

  <div class="section" *ngIf="vm.status === 'running' && vm.currentItemTotal > 0">
    <div class="row">
      <span>{{ 'SYNC_PROGRESS.ITEM_LABEL' | translate:{ done: vm.currentItemDone, total: vm.currentItemTotal } }}</span>
      <span>{{ vm.itemProgress }}%</span>
    </div>
    <mat-progress-bar mode="determinate" [value]="vm.itemProgress"></mat-progress-bar>
  </div>

  <div class="section" *ngIf="vm.status === 'running' && vm.showPhotoProgress && vm.currentItemTotal > 0 || vm.photoProgressMode !== 'determinate'">
    <div class="row">
      <span>{{ vm.photoProgressLabel }}</span>
      <span *ngIf="vm.photoProgressMode === 'determinate'">{{ vm.photoProgress }}%</span>
    </div>
    <mat-progress-bar [mode]="vm.photoProgressMode" [value]="vm.photoProgress"></mat-progress-bar>
  </div>

  <div class="section">
    <label>{{ 'SYNC_PROGRESS.LOG_LABEL' | translate }}</label>
    <textarea #logTextarea readonly wrap="off" [value]="getLogsText(vm.logs)"></textarea>
  </div>

  <div class="section" *ngIf="vm.sortedTaskResults.length">
    <label>{{ 'SYNC_PROGRESS.RESULTS_LABEL' | translate }}</label>
    <div class="task-results">
      <div
        class="task-result"
        *ngFor="let result of vm.sortedTaskResults"
        [ngClass]="result.status === 'success' ? 'task-result-success' : 'task-result-failed'">
        <div class="task-result-top">
          <span class="task-result-title">{{ getTaskResultHeader(result) }}</span>
          <button
            *ngIf="vm.status !== 'running' && canDeleteOfflineData(result)"
            mat-stroked-button
            color="warn"
            class="delete-offline-btn"
            (click)="deleteOfflineData(result.taskId)"
            [disabled]="deletingTaskIds.has(result.taskId)">
            {{ 'SYNC_PROGRESS.DELETE_OFFLINE_DATA' | translate }}
          </button>
          <span class="delete-offline-done" *ngIf="isOfflineDataDeleted(result.taskId)">
            {{ 'SYNC_PROGRESS.DELETE_OFFLINE_DATA_DONE' | translate }}
          </span>
        </div>
        <p class="task-result-reason">
          {{ renderTaskResultReason(result) }}
          <span class="task-result-original" *ngIf="getTaskResultOriginalMessage(result)">
            ({{ getTaskResultOriginalMessage(result) }})
          </span>
        </p>
        <div class="photo-issues" *ngIf="result.photoIssues?.length">
          <article class="photo-issue" *ngFor="let issue of result.photoIssues">
            <img
              *ngIf="issue.thumbnail; else photoPlaceholder"
              class="photo-issue-thumbnail"
              [src]="issue.thumbnail"
              [alt]="issue.originalFilename">
            <ng-template #photoPlaceholder>
              <div class="photo-issue-thumbnail photo-issue-placeholder">
                <mat-icon>broken_image</mat-icon>
              </div>
            </ng-template>
            <div class="photo-issue-details">
              <strong class="photo-issue-filename">{{ issue.originalFilename }}</strong>
              <span><b>{{ 'SYNC_PROGRESS.PHOTO_ISSUE_POSITION' | translate }}:</b> {{ getPhotoIssuePath(issue) }}</span>
              <span *ngIf="issue.controlLabel"><b>{{ 'SYNC_PROGRESS.PHOTO_ISSUE_CONTROL' | translate }}:</b> {{ issue.controlLabel }}</span>
              <span *ngIf="issue.failureName"><b>{{ 'SYNC_PROGRESS.PHOTO_ISSUE_FAILURE' | translate }}:</b> {{ issue.failureName }}</span>
              <span><b>{{ 'SYNC_PROGRESS.PHOTO_ISSUE_PROBLEM' | translate }}:</b> {{ getPhotoIssueReason(issue) }}</span>
              <span class="photo-issue-id">{{ 'SYNC_PROGRESS.PHOTO_ISSUE_LOCAL_ID' | translate:{ id: issue.localId } }}</span>
            </div>
            <button
              mat-flat-button
              color="primary"
              class="go-to-task-btn"
              (click)="goToTask(result, issue)">
              <mat-icon>open_in_new</mat-icon>
              {{ 'SYNC_PROGRESS.GO_TO_TASK' | translate }}
            </button>
          </article>
        </div>
      </div>
    </div>
  </div>

  <buttons-wrapper>
    <button mat-flat-button color="primary" (click)="confirmStop()" [disabled]="!vm.canStop">
      {{ 'SYNC_PROGRESS.STOP' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="close()" [disabled]="!vm.canClose">
      {{ 'SYNC_PROGRESS.CLOSE' | translate }}
    </button>
  </buttons-wrapper>
</div>
